import React from 'react';
import { Paperclip, FileText, ExternalLink, Eye } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { isPdfUrl, formatCurrency, formatDate } from './utils';

export const VerComprobantesDialog = ({ pago, onClose }) => (
  <Dialog open={!!pago} onOpenChange={(o) => { if (!o) onClose(); }}>
    <DialogContent className="sm:max-w-[700px] max-h-[85vh] overflow-y-auto" data-testid="modal-ver-comprobantes">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Paperclip className="w-5 h-5" /> Comprobantes del Pago
        </DialogTitle>
        {pago && (
          <p className="text-sm text-muted-foreground">
            {pago.cliente_nombre} · Factura {pago.factura_numero} · {formatCurrency(pago.monto || 0)} · {formatDate(pago.fecha)}
          </p>
        )}
      </DialogHeader>

      {pago && Array.isArray(pago.comprobantes) && pago.comprobantes.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 py-2">
          {pago.comprobantes.map((c, idx) => {
            const url = typeof c === 'string' ? c : c.url;
            const filename =
              typeof c === 'string'
                ? (url.split('/').pop() || `comprobante-${idx + 1}`)
                : (c.filename || `comprobante-${idx + 1}`);
            const ctype = typeof c === 'string' ? '' : (c.content_type || '');
            const isPdf = ctype.includes('pdf') || isPdfUrl(url);
            return (
              <div key={idx} className="border rounded-lg overflow-hidden bg-muted/30 flex flex-col">
                {isPdf ? (
                  <div className="h-48 flex flex-col items-center justify-center bg-red-50 dark:bg-red-950/20 text-red-700">
                    <FileText className="w-12 h-12" />
                    <span className="text-xs mt-2 font-medium">PDF</span>
                  </div>
                ) : (
                  <a href={url} target="_blank" rel="noopener noreferrer" className="block">
                    <img
                      src={url}
                      alt={filename}
                      className="h-48 w-full object-cover hover:opacity-90 transition-opacity"
                      loading="lazy"
                    />
                  </a>
                )}
                <div className="p-2 bg-background flex items-center justify-between gap-2">
                  <span className="text-xs truncate flex-1" title={filename}>{filename}</span>
                  <div className="flex gap-1 shrink-0">
                    <a
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center h-7 w-7 rounded-md hover:bg-accent text-muted-foreground"
                      title="Abrir"
                      data-testid={`btn-abrir-comprobante-${idx}`}
                    >
                      <ExternalLink className="w-3.5 h-3.5" />
                    </a>
                    <a
                      href={url}
                      download={filename}
                      className="inline-flex items-center justify-center h-7 w-7 rounded-md hover:bg-accent text-muted-foreground"
                      title="Descargar"
                      data-testid={`btn-descargar-comprobante-${idx}`}
                    >
                      <Eye className="w-3.5 h-3.5" />
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center py-8 text-muted-foreground">
          <Paperclip className="w-12 h-12 mx-auto mb-3 opacity-30" />
          <p>No hay comprobantes adjuntos</p>
        </div>
      )}

      <DialogFooter>
        <Button variant="outline" onClick={onClose}>Cerrar</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
